import { render, staticRenderFns } from "./review_general_tab.vue?vue&type=template&id=02535290&scoped=true&"
import script from "./review_general_tab.vue?vue&type=script&lang=js&"
export * from "./review_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02535290",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02535290')) {
      api.createRecord('02535290', component.options)
    } else {
      api.reload('02535290', component.options)
    }
    module.hot.accept("./review_general_tab.vue?vue&type=template&id=02535290&scoped=true&", function () {
      api.rerender('02535290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/review/location/tabs/review_general_tab.vue"
export default component.exports